import React  , {useState} from 'react';
import Input from './Input';
import ImageFile from '../../models/ImageFile'

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});


export default function ImageFileSelector({onFileSelected}){

    const processFiles = async (files) => {
        
        const file = files[0];
        
        const reader = new FileReader();

        const previewUrl = URL.createObjectURL(file);
        //await toBase64(file);
        console.log(previewUrl);
        const selectedFile = ImageFile(file.name,previewUrl,file);
        console.log('imageFileSelector')
        console.log(selectedFile)
        return selectedFile;
        
    }

    return(
        <div>
            <input 
                type="file" 
                onChange={async (e)=> {
                    
                    const selectedFile = await processFiles(e.target.files);

                    if(onFileSelected){
                        onFileSelected(selectedFile);
                    }
                    
                }} 
            />
        </div>
     )
}